import { render, staticRenderFns } from "./UiShowDiscountsList.vue?vue&type=template&id=8fae3d74&lang=pug&"
import script from "./UiShowDiscountsList.vue?vue&type=script&lang=js&"
export * from "./UiShowDiscountsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports